import AriaControl from "../../../utilities/accessibility/js/AriaControl";
import { _defaultConfigOptions } from "../../../utilities/accessibility/js/constants";

export default class Counter extends AriaControl {
  /**
   * Default config that we control the ARIA attributes with
   */
  static defaultConfigOptions = _defaultConfigOptions;

  constructor({ control }) {
    // Initialise ARIA
    super({ control });

    // Initialise button
    this.control = control;
    this.target = document.querySelector(
      `[data-controlled-by*=${this.control.id}]`
    );

    // Add event listener to target
    this.target.addEventListener("input", this.handleChange.bind(this));
  }

  countWords(str) {
    return str.split(" ").filter(function (n) {
      return n != "";
    }).length;
  }

  /**
   * Do the count
   */
  handleChange(event) {
    const maxWords = parseInt(event.target.getAttribute("data-max-words"));
    const currentWords = this.countWords(event.target.value);

    if (currentWords > maxWords) {
      let currentWords = event.target.value.split(" ");
      currentWords = currentWords.slice(0, maxWords);
      event.target.value = currentWords.join(" ");
      return;
    }
    let len = `${maxWords - currentWords}/<span>${maxWords}<span>`;
    this.control.innerHTML = len;
  }
}
